import { render, staticRenderFns } from "./AdquisicionProducto.vue?vue&type=template&id=17477f09"
import script from "./AdquisicionProducto.vue?vue&type=script&lang=js"
export * from "./AdquisicionProducto.vue?vue&type=script&lang=js"
import style0 from "./AdquisicionProducto.vue?vue&type=style&index=0&id=17477f09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports